<script setup lang="ts">
import { vNavigateLinks } from '~/entities/article/directives/v-navigate-links';
import type { IArticleRelatedNewsItem } from '../model/article.interfaces';
import { resizeImageAttrs } from '~/shared/lib/resizeImage';

const props = defineProps<IArticleRelatedNewsItem>();
const imageAttrs = computed(() =>
  resizeImageAttrs(props.image, { width: 320 }),
);
</script>

<template>
  <div v-navigate-links :class="$style.item">
    <a v-if="image" :class="$style.item__imageWrapper" :href="link">
      <img
        :src="imageAttrs.src"
        :srcset="imageAttrs.srcset"
        :alt="props.title"
        :class="$style.item__image"
      />
    </a>

    <div :class="$style.item__info">
      <a
        v-if="props.category"
        :class="$style.item__category"
        :href="categoryLink"
      >
        {{ props.category }}
      </a>
      <a :class="$style.item__title" :href="link">
        {{ props.title }}
      </a>
      <div v-if="props.subject" :class="$style.item__description">
        {{ props.subject }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.item {
  display: flex;
  flex-flow: row nowrap;
  padding: 20px;
  gap: 40px;
  position: relative;
  border: 1px solid var(--color-gray-line);

  &__image {
    max-width: 320px;
    height: auto;
    display: flex;
    &Wrapper {
      flex-shrink: 0;
      background: none;
    }
  }

  a#{&}__imageWrapper {
    background: none;
  }

  &__info {
    display: flex;
    flex-flow: column nowrap;
    gap: 8px;
  }

  // Перебить стили обычных ссылок в статье
  a.item__category {
    display: block;
    @include text_caption2_caps;
    color: var(--color-gray-text);
    text-decoration: none;
    background: none;
    &:hover {
      color: var(--color-gray-text);
    }
  }

  a.item__title {
    display: block;
    @include text_body1_large_medium;
    color: var(--color-black-1);
    text-decoration: none;
    background: none;

    &:hover {
      color: var(--color-black-1);
    }
  }

  &__description {
    @include text_body2;
    color: var(--color-black-1);
    text-decoration: none;
  }
}

@media (max-width: 767px) {
  .item {
    flex-direction: column;
    gap: var(--space-1-5x);

    &__image {
      max-width: 100%;
      width: 100%;
    }

    &__description {
      display: none;
    }
  }
}

@media (max-width: 479px) {
  .item {
    padding: 16px;
  }
}
</style>
